<template>
  <div class="all lianchulianbei home_page" v-loading="noticeLoading">
    <div v-if="!noticeLoading">
      <joining-notice v-show="showNotice" :showControl="showControl" @joinSuccess="joinSuccess"></joining-notice>
      <el-row class="search-card" v-show="!showNotice">
        <el-col :span="4">
          <div class="left">
            <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick">
              <span class="custom-tree-node" slot-scope="{ node, data }" :title="node.label">
                <span>{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
        </el-col>
        <el-col :span="20">
          <div>
            <div class="search">
              筛选条件
              <div class="btn">
                <el-button type="text" @click="clickShowJoiningNotice">免责说明</el-button>
              </div>
            </div>
            <div>
              <el-row>
                <el-col :span="7">
                  <div class="filed">
                    <label class="label">备件编码：</label>
                    <div class="value">
                      <el-input v-model="form.supplyCode" clearable placeholder="请输入"></el-input>
                    </div>
                  </div>
                </el-col>
                <el-col :span="7">
                  <div class="filed">
                    <label class="label">备件名称：</label>
                    <div class="value">
                      <el-input v-model="form.sparePartsName" clearable placeholder="请输入"></el-input>
                    </div>
                  </div>
                </el-col>
                <el-col :span="7">
                  <div class="filed">
                    <label class="label">规格型号：</label>
                    <div class="value">
                      <el-input v-model="form.model" clearable placeholder="请输入"></el-input>
                    </div>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="btns">
                    <el-button type="primary" @click="clickSearch">查询</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="7">
                  <div class="filed">
                    <label class="label">品牌：</label>
                    <div class="value">
                      <el-select
                        v-model="form.brand"
                        filterable
                        clearable
                        remote
                        reserve-keyword
                        placeholder="请输入关键词"
                        :remote-method="remoteMethod"
                        :loading="brandSelectLoading">
                        <el-option
                          v-for="item in brandOptions"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </el-col>
                <el-col :span="7">
                  <div class="filed">
                    <label class="label">备件状态：</label>
                    <div class="value">
                      <el-select v-model="form.status" clearable placeholder="请选择">
                        <el-option
                          v-for="item in statusOption"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </el-col>
                <el-col :span="7">
                  <div class="filed">
                    <label class="label">更新时间：</label>
                    <div class="value">
                      <el-date-picker
                        value-format="yyyy-MM-dd"
                        v-model="daterangeValue"
                        style="width: 188px"
                        type="daterange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                      </el-date-picker>
                    </div>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="btns">
                    <el-button @click="clickReset">重置</el-button>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="table-card">
            <div class="btnlist">
              <el-button type="primary" @click="clickAdd">手动新增</el-button>
              <!-- <el-button>批量导入</el-button>
              <el-button type="text" icon="el-icon-download">下载导入模板</el-button> -->
            </div>
            <el-table
              v-loading="tableLoading"
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column
                type="index"
                header-align="center"
                align="center"
                label="序号"
                width="50">
              </el-table-column>
              <el-table-column
                prop="date"
                label="商品信息">
                <template slot-scope="scope">
                  <good-detail :dataInfo="scope.row.dataInfo" class="sharedSparePartsGD"></good-detail>
                </template>
              </el-table-column>
              <el-table-column
                prop="supplyNum"
                align="center"
                width="100"
                label="供应数量">
              </el-table-column>
              <el-table-column
                prop="price"
                width="120"
                header-align="center"
                align="right"
                label="价格">
                <template slot-scope="scope">
                  ￥{{scope.row.price}}
                </template>
              </el-table-column>
              <el-table-column
                prop="status"
                align="center"
                width="80"
                label="状态">
                <template slot-scope="scope">
                  <el-switch
                    @change="(val) => changeSwitch(val, scope.row)"
                    :value="scope.row.status"
                    active-color="#0064C0"
                    inactive-color="#E1E1E1">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="60"
              >
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="small"
                    @click="clickDetail(scope.row)"
                    >查看</el-button
                  >
                  <el-button
                    style="margin-left: 0"
                    type="text"
                    size="small"
                    @click="clickEdit(scope.row)"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-pagination @size-change="sizeChangeHandle"
              @current-change="currentChangeHandle"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              :total="totalPage"
              layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addDialogVisible"
      @close="closeDialog"
      :close-on-click-modal="false"
      width="80%">
      <add-new @cancel="clickDialogCancel" ref="addNew"></add-new>
    </el-dialog>
  </div>
</template>

<script>
import addNew from './add'
import goodDetail from './components/goodDetail'
import joiningNotice from './joiningNotice'
export default {
  name: 'sharedSpareParts', // 备件发布列表
  components: {
    joiningNotice,
    goodDetail,
    addNew
  },
  data () {
    return {
      dialogTitle: '新增备件',
      daterangeValue: [],
      form: {
        supplyCode: '',
        sparePartsName: '',
        model: '',
        brand: '',
        startModifyTime: '',
        endModifyTime: '',
        status: null,
        backgroundCategoryId: null
      },
      brandOptions: [],
      brandSelectLoading: false,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      clickedNode: null,
      showNotice: true,
      showControl: true,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 0, // 总页数
      pageSize: 10,
      statusOption: [
        {
          value: true,
          label: '可用'
        }, {
          value: false,
          label: '不可用'
        }
      ],
      tableData: [],
      tableLoading: false,
      noticeLoading: true,
      addDialogVisible: false
    }
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.brandSelectLoading = true
        let params = {
          brand: query,
          type: 'PC'
        }
        this.$http.post(`/front/order/lclb/sparePartsShare/brandList`, params)
          .then(({ data }) => {
            if (data.code === 0) {
              this.brandOptions = data.data
            }
            this.brandSelectLoading = false
          })
          .catch(() => {
            this.brandOptions = []
            this.brandSelectLoading = false
          })
      } else {
        this.brandOptions = []
      }
    },
    getTreeData () {
      this.$http.get(`/front/order/lclb/sparePartsShare/menuList`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.treeData = data.data
          } else {
            this.treeData = []
          }
        })
        .catch(() => {
          this.treeData = []
        })
    },
    getTableData () {
      this.tableLoading = true
      let params = {
        page: this.currentPage,
        limit: this.pageSize,
        companyId: this.$store.state.user.defaultCompanyId,
        supplyCode: this.form.supplyCode,
        sparePartsName: this.form.sparePartsName,
        model: this.form.model,
        brand: this.form.brand,
        startModifyTime: this.daterangeValue ? (this.daterangeValue[0] || '') : '',
        endModifyTime: this.daterangeValue ? (this.daterangeValue[1] || '') : '',
        status: this.form.status === '' ? null : this.form.status,
        backgroundCategoryId: this.form.backgroundCategoryId
      }
      this.$http.post(`/front/order/lclb/sparePartsShare/sendlList`, params)
        .then(({ data }) => {
          if (data.code === 0) {
            data.data.data.map(item => {
              item.dataInfo = {
                url: item.url,
                name: item.sparePartsName,
                norms: item.model,
                brand: item.brand,
                type: item.supplyCode
              }
            })
            this.tableData = data.data.data
            this.totalPage = data.data.count
          } else {
            this.tableData = []
            this.totalPage = 0
          }
          this.tableLoading = false
        })
        .catch(() => {
          this.tableData = []
          this.totalPage = 0
          this.tableLoading = false
        })
    },
    getJoinNoticeMessage () {
      this.noticeLoading = true
      let params = {
        companyId: this.$store.state.user.defaultCompanyId
      }
      this.$http.post(`/front/user/sys/custCompany/joinNoticeMessage`, params)
        .then(({ data }) => {
          if (data.code === 0) {
            if (data.data.isJoin === 1) {
              this.showNotice = false
              this.showControl = false
              this.getTreeData()
              this.getTableData()
            }
          }
          this.noticeLoading = false
        })
        .catch(() => {
          this.noticeLoading = false
        })
    },
    clickShowJoiningNotice () {
      this.showNotice = true
    },
    handleNodeClick (node) {
      if (node.level === 3) {
        this.clickedNode = node
      } else {
        this.clickedNode = null
      }
      this.form.backgroundCategoryId = node.backgroundCategoryId
      this.currentPage = 1
      this.getTableData()
    },
    clickDetail (row) {
      this.dialogTitle = '备件详情'
      this.$http.get(`/front/order/lclb/sparePartsShare/info/${row.sparePartsId}`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.addDialogVisible = true
            // this.$refs.addNew.editInit(this.clickedNode)
            this.$nextTick(() => {
              data.data.foregroundCategoryId = data.data.backgroundCategoryId
              // this.$refs.addNew.init(data.data)
              data.data.isDetail = true
              this.setDataForm(data.data)
            })
          }
        })
        .catch(() => {

        })
    },
    setDataForm (data) {
      this.$refs.addNew.setDataForm(data)
    },
    clickEdit (row) {
      this.dialogTitle = '编辑备件'
      this.$http.get(`/front/order/lclb/sparePartsShare/info/${row.sparePartsId}`)
        .then(({ data }) => {
          if (data.code === 0) {
            this.addDialogVisible = true
            // this.$refs.addNew.editInit(this.clickedNode)
            this.$nextTick(() => {
              data.data.foregroundCategoryId = data.data.backgroundCategoryId
              // this.$refs.addNew.init(data.data)
              this.setDataForm(data.data)
            })
          }
        })
        .catch(() => {

        })
    },
    clickSearch () {
      this.form.backgroundCategoryId = null
      this.getTableData()
    },
    clickReset () {
      this.daterangeValue = []
      this.form.supplyCode = ''
      this.form.sparePartsName = ''
      this.form.model = ''
      this.form.brand = ''
      this.form.startModifyTime = ''
      this.form.endModifyTime = ''
      this.form.status = null
      this.form.backgroundCategoryId = null
      this.currentPage = 1
      this.getTableData()
    },
    joinSuccess () {
      this.showNotice = false
      this.showControl = false
      this.getTreeData()
      this.getTableData()
    },
    closeDialog () {
      this.$refs.addNew.resetDataForm()
    },
    clickDialogCancel (refresh) {
      this.addDialogVisible = false
      if (refresh) {
        this.getTableData()
      }
    },
    // 新增
    clickAdd () {
      if (!this.clickedNode) {
        this.$message.error('请选择三级类目后再新增')
        return
      }
      this.addDialogVisible = true
      this.$nextTick(() => {
        this.$refs.addNew.init(this.clickedNode)
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    // 当前页
    currentChangeHandle (val) {
      this.currentPage = val
      this.getTableData()
    },
    changeSwitch (value, row) {
      if (!value) {
        this.$confirm('是否确认禁用该备件？', '提示', {
          confirmButtonText: '确定',
          showCancelButton: true,
          type: 'warning'
        }).then(() => {
          let params = {
            sparePartsId: row.sparePartsId,
            status: value
          }
          this.$http.post(`/front/order/lclb/sparePartsShare/updateStatus`, params)
            .then(({ data }) => {
              if (data.code === 0) {
                this.getTableData()
              }
            })
        }).catch(() => {
          this.tableData.map(item => {
            if (row.sparePartsId === item.sparePartsId) {
              item.status = true
            }
          })
        })
      } else {
        let params = {
          sparePartsId: row.sparePartsId,
          status: value
        }
        this.$http.post(`/front/order/lclb/sparePartsShare/updateStatus`, params)
          .then(({ data }) => {
            if (data.code === 0) {
              this.getTableData()
            }
          })
      }
    }
  },
  created () {
    this.getJoinNoticeMessage()
  }
}
</script>

<style lang="scss" scoped>
.search-card {
  border-radius: 6px;
  background: #ffffff;
}
.lianchulianbei {
  background: white;
  padding: 20px;
  padding-top: 5px;
  // border-top: 1px solid #ccc;
}
.left {
  margin-right: 20px;
}
.search {
  font-weight: bold;
  font-size: 16px;
  color: #333;
  padding: 16px 20px;
  border-bottom: 1px solid #ccc;
  .btn {
    margin-top: -10px;
    float: right;
  }
}
.filed {
  padding: 10px 5px 0 5px;
  line-height: 32px;
  .label {
    display: inline-block;
    font-size: 14px;
    color: #666666;
    width: 80px;
    text-align: right;
  }
  .value {
    width: 188px;
    display: inline-block;
  }
}
.btns {
  padding: 10px 10px 0 10px;
}
.table-card {
  margin-top: 20px;
  padding: 20px;
}
.btnlist {
  margin-bottom: 10px;
}
.custom-tree-node {
  text-overflow: ellipsis;
  overflow: hidden;
}
.sharedSparePartsGD {
  /deep/ .detailname {
    max-width: 240px;
  }
}
</style>
